// src/redux/credibilityChip/credibilityChipAPI.js
import apiClient from "../../authentication/utils/core/axios";

const CredibilityChipAPI = {
  async fetchPostChip(postId) {
    const res = await apiClient.get(`/postchip/${postId}`);
    return res.data;
  },

  async fetchUserChips(userId) {
    const res = await apiClient.get(`/postchip/user/${userId}`);
    return res.data;
  },
};

export default CredibilityChipAPI;
